import { createContext } from 'react';
import { I18nextProvider } from 'react-i18next';
import { jsxs, jsx } from 'react/jsx-runtime';

const I18nContext = /*#__PURE__*/createContext({});
const I18nProvider = ({
  locale,
  i18n,
  children
}) => {
  return /*#__PURE__*/jsxs(I18nContext.Provider, {
    value: {
      locale,
      i18n
    },
    children: [i18n && /*#__PURE__*/jsx(I18nextProvider, {
      i18n: i18n,
      children: children
    }), !i18n && children]
  });
};

export { I18nContext, I18nProvider };
